<app-general-feed *ngIf="!id" [allCases]="true"></app-general-feed>

